import { Reveal, Eyebrow } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "A Hook from Mom",
    body: "My love for crochet started when I was just 10 years old. I can still remember watching my mom crochet and constantly asking her, “How did you do that?” I must have asked enough times, because eventually she handed me a crochet hook and a ball of yarn — and that's where it all began.",
  },
  {
    num: "02",
    title: "Learning in Earnest",
    body: "I practiced over the years, but it wasn't until college that I took it seriously — hours of YouTube tutorials, new stitches and techniques, until I taught myself to read and follow written patterns. What started with a hook and a ball of yarn from my mom grew into something I truly love.",
  },
  {
    num: "03",
    title: "For My Two Girls",
    body: "Crochet became my creative outlet and one of my favourite ways to make something special for the people I love. Some of my absolute favourites are the pieces I've created for my two girls. Today, Double Treble Stitches is my way of sharing that love with you.",
  },
];

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal>
          <Eyebrow testId="story-eyebrow">The Story Behind the Stitches</Eyebrow>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-[#2C2520] sm:text-4xl lg:text-5xl">
            Every piece is handmade by me, <span className="italic text-[#A35C45]">one stitch at a time.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:gap-8 md:grid-cols-3 lg:gap-10">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.12}>
              <article
                data-testid={`story-chapter-${c.num}`}
                className="group h-full rounded-2xl border border-[#E6DFD5] bg-[#FAF7F2] p-6 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#C88A75]/50 hover:shadow-[0_24px_50px_-20px_rgba(44,37,32,0.18)] sm:p-8"
              >
                <span className="font-serif text-5xl font-semibold italic text-[#C88A75]/60 transition-colors duration-500 group-hover:text-[#A35C45]">{c.num}</span>
                <h3 className="mt-5 font-serif text-2xl font-medium tracking-tight text-[#2C2520]">{c.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-[#6E6259] sm:text-base">{c.body}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <blockquote data-testid="story-quote" className="mx-auto mt-20 max-w-3xl text-center">
            <div className="wavy-divider mx-auto mb-10 h-3 w-40 opacity-70" />
            <p className="font-serif text-2xl font-medium italic leading-snug text-[#2C2520] sm:text-3xl">
              “From my mom&apos;s crochet hook, to my hands, to something made especially for you.”
            </p>
            <footer className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-[#8C7A6B]">
              — Carol Elisabeth Smith · the hands behind Double Treble Stitches
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}
